import React, {Component} from "react"
import {Route} from "react-router-dom"
import PropTypes from "prop-types"
import {LangLoader} from "../../lang"

interface ContextRouteProps {
  app: string
  apps: {[key: string]: string}
  routes: any
  routesProps: any
}

export default class ContextRoute extends Component<ContextRouteProps> {
  static defaultProps = {
    routesProps: {}
  }

  static childContextTypes = {
    appPath: PropTypes.string.isRequired,
    apps: PropTypes.object.isRequired,
    app: PropTypes.string.isRequired
  }

  getChildContext() {
    return {
      appPath: this.getPath(),
      app: this.props.app,
      apps: this.props.apps
    }
  }

  getPath = () => this.props.apps[this.props.app]

  render() {
    const {routes: Routes, routesProps, app} = this.props
    const path = this.getPath()

    return (
      <Route
        path={path}
        render={() => (
          <LangLoader bucket={app}>
            <Routes path={path} {...routesProps} />
          </LangLoader>
        )}
      />
    )
  }
}
